import { render } from "./AddEditParticiple.vue?vue&type=template&id=e92677aa&scoped=true"
import script from "./AddEditParticiple.vue?vue&type=script&lang=js"
export * from "./AddEditParticiple.vue?vue&type=script&lang=js"

import "./AddEditParticiple.vue?vue&type=style&index=0&id=e92677aa&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e92677aa"]])

export default __exports__